export default "__VITE_ASSET__D$ON1sfY__"